import ApiService from 'services/api/api.service'
import store from 'state/store/store'
import { setAuth, setUser } from 'state/actions'

class AuthService {

    parseErrors(error) {
        return ApiService.parseErrors(error)
    }

    async login(data, dispatchevent = true) {
        window.localStorage.clear()

        try {
            const response = await ApiService.postData('auth', data)

            if (response.data.token) {
                store.dispatch(setUser(response.data.user))
                if (dispatchevent) {
                    setTimeout(() => {
                        store.dispatch(setAuth(true))
                    }, 1000)
                }
            }

            return response.data
        } catch (error) {
            
            if (error?.response?.data?.errors === 'need to check 2fa' || error?.response?.data?.errors === 'Unauthorised') {
                throw error
            }

            throw new Error(this.parseErrors(error))
        }
    }

    async create(data) {
        try {
            const response = await ApiService.postData('registration', data, true)

            if (response.data.token) {
                const authResult = response.data
                localStorage.setItem("expires_at", authResult.expires_at)
                store.dispatch(setAuth(true))
                store.dispatch(setUser(authResult.user))
            }

            return response.data
        } catch (error) {
            throw error
            //throw new Error(this.parseErrors(error))
        }
    }

    async logout() {
        try {
            const response = await ApiService.getData('logout')
            store.dispatch(setUser(null))
            store.dispatch(setAuth(false))
            return response.data
        } catch (error) {
            // даже если logout падает, сбрасываем state
            store.dispatch(setUser(null))
            store.dispatch(setAuth(false))
            throw new Error(this.parseErrors(error))
        }
    }

    checkSession() {
        // проверка наличия user cookie (не валидность токена)
        return ApiService.checkSession()
    }

    async checkAuth() {
                
        try {
            const response = await ApiService.postData('check_auth')
            if (response.data?.user) {
                store.dispatch(setUser(response.data.user))
                store.dispatch(setAuth(true))
                return response.data
            } else {
                // backend вернул пустой объект → считаем неавторизованным
                store.dispatch(setUser(null))
                store.dispatch(setAuth(false))
                return null
            }
        } catch (error) {
            // 401 или другая ошибка → сброс state
            store.dispatch(setUser(null))
            store.dispatch(setAuth(false))
            // backend очистил HttpOnly cookie, поэтому фронт только сбрасывает state
            return null
        }
    }

    async restore(data) {
        try {
            const response = await ApiService.postData('restore', data)
            return response.data
        } catch (error) {
            throw new Error(this.parseErrors(error))
        }
    }
}

const authService = new AuthService()
export default authService